
import { Button, Flex } from '@chakra-ui/react';
import { useState } from 'react';

import Dialog from '@app/components/common/modals/dialog';
import { TextField, Txt } from '@app/components/common';

import { ActionDialogProps } from './types';

export const CancelDialog = ({ onAction, selectedTx, actionName }: ActionDialogProps) => {
  const [open, setOpen] = useState(false);
  const [comment, setComment] = useState('');
  return <>
    <Button colorScheme='gray' onClick={() => setOpen(true)} >{actionName}</Button>
    <Dialog
      open={open}
      title="Отменить транзакцию"
      onClose={() => setOpen(false)}
      actions={[
        <Button variant='solid' colorScheme='red' key='cancel' onClick={() => {
          onAction(selectedTx, comment);
          setOpen(false);
        }} >Подтвердить</Button>
      ]}
    >
      <Flex direction='column' gap={4}>
        <Txt>Отменить перемещение ХО?</Txt>
        <TextField multiline value={comment} label='Причина' onChange={setComment} id='comment'/>
      </Flex>
    </Dialog>
  </>;
};